export default "__VITE_ASSET__1609d6b3__"